type ItemType = {
  section_name: any;
  is_system_field: boolean;
  field_type: string;
  label: string;
  name?: string;
  placeholder: string;
  default_value: any;
  validation: any[];
  is_multiline: any;
  section_order: any;
  option?: any;
  time_format?: string;
  currency?: string;
  field_properties: {
    is_accordion?: boolean;
    float_step?: any;
    options: any;
    is_multiselect: any;
    title: string;
    title_position: "start" | "end";
    is_multiline: boolean
    is_checked: boolean
    table: string,
    table_columns: string[]
    table_rows?: any
    is_multiple: boolean
    enable_footer?: boolean
    footer_action?: 'add'
    other_buttons?: React.ReactNode[]
  };
  is_section_field?: true;
  section_type?: "default" | "Form switcher section";
  form_switcher_label?: string;
  form_switcher_name?: string;
  switcher_forms?: {
    value?: string;
    name?: string;
    id?: number;
  }[];
  is_accordion?: boolean;
}

const getFirstNonSectionField = (formData: any[]) => {
  const firstField = formData?.find((field) => !field.is_section_field)
  return firstField
}

const formBuilderDeConversion = (formData: any) => {
  const outputData: any = {};
  if (formData.length === 0) {
    return outputData;
  }

  const firstItem = getFirstNonSectionField(formData);

  if (firstItem?.tab_name) {
    outputData.tab = <any>[];
    let currentTab: {
      title: string;
      data: any;
      remove_tab?: any;
      tab_order?: any;
    } | null = null;
    let currentSection: {
      label: string;
      members: any;
      remove_section: any;
      field_type?: string;
      is_accordion?: boolean;
    } | null = null;
    let otherSectionDetails: any = {}
    let sectionOrder: any = null

    formData.forEach((item: any) => {
      if (item?.is_section_field) {
        otherSectionDetails = {
          field_type: item?.field_type,
          label: item?.label,
          is_accordion: item?.is_accordion,
          is_section_field: item?.is_section_field,
          section_type: item?.section_type,
          form_switcher_label: item?.form_switcher_label,
          form_switcher_name: item?.form_switcher_name,
          switcher_forms: item?.switcher_forms,
          disabled: Boolean(item?.disabled)
        }
        currentSection = null
        sectionOrder = sectionOrder++
      } else {
        if (!currentTab || currentTab.title !== item.tab_name) {

          currentTab = {
            tab_order: item.tab_order || 1,
            title: item.tab_name,
            data: [],
          };
          const checkIfTabExist = outputData.tab.find(tab => tab.title === currentTab?.title)

          if (!checkIfTabExist) {
            outputData.tab.push(currentTab);
          } else {
            currentTab = checkIfTabExist
          }
          currentSection = null;
        }

        if (!currentSection || currentSection.label !== item.section_name || sectionOrder !== item.section_order) {
          currentSection = {
            field_type: "section",
            label: item.section_name || "",
            is_accordion: item.field_properties?.is_accordion,
            members: [],
            remove_section: item.is_system_field === true ? true : false,
          };

          const checkIfSectionExist = currentTab.data.find(section => section.label === currentSection?.label)
          if (!checkIfSectionExist) {
            // Merge section details and update currentSection reference to the actual pushed object
            currentSection = { ...otherSectionDetails, ...currentSection };
            currentTab.data.push(currentSection);
          } else {
            currentSection = checkIfSectionExist
          }
          otherSectionDetails = null
        }
        sectionOrder = item.section_order

        const thenValidations = item?.validation?.find((v: { type: string }) => v.type === "when")?.thenValidations || []

        const member = {
          ...item,
          id: `${Date.now()}-${Math.random()}`,
          field_type:
            item.field_type === "media" ? "file" : item.field_type || "text",
          type: item.is_system_field ? "system" : "custom",
          label: item.label || "",
          placeholder: item.placeholder || "",
          default_value: item.default_value || "",
          ...(item?.time_format &&
            item?.field_type === "time" && { option: item?.time_format }),
          ...(item?.currency &&
            item?.field_type === "currency" && { option: item?.currency }),
          ...(item.field_type === "text" && {
            min_length:
              item.validation.find(
                (v: { type: string }) => v.type === "min_length",
              )?.value || null,
          }),
          ...(item.field_type === "text" && {
            max_length:
              item.validation.find(
                (v: { type: string }) => v.type === "max_length",
              )?.value || null,
          }),
          ...(item.field_type === "number" && {
            min_length:
              item.validation.find((v: { type: string }) => v.type === "min_val")
                ?.value || null,
          }),
          ...(item.field_type === "number" && {
            max_length:
              item.validation.find((v: { type: string }) => v.type === "max_val")
                ?.value || null,
          }),
          ...((item.is_multiline !== undefined || item.field_properties?.is_multiline !== undefined) && {
            is_multiline: item.is_multiline || item.field_properties?.is_multiline,
          }),
          is_required:
            item.validation.find((v: { type: string }) => v.type === "required")?.value ||
            thenValidations?.find((v: { type: string }) => v.type === "required")?.value ||
            false,
          is_unique:
            item.validation.find((v: { type: string }) => v.type === "unique")
              ?.value || false,
          section_order: item.section_order || 0,
          ...(item.field_properties?.float_step && {
            float_step: item.field_properties.float_step.toString(),
          }),
          ...(item.field_properties?.options && {
            options: item.field_properties.options,
          }),
          ...(item.field_properties?.is_multiselect !== undefined && {
            is_multiselect: item.field_properties.is_multiselect,
          }),
          ...(item.field_properties?.enable_footer !== undefined && {
            enable_footer: Boolean(item.field_properties.enable_footer),
          }),
          ...(item.field_properties?.footer_action !== undefined && {
            footer_action: item.field_properties.footer_action || 'add',
          }),
          ...(item.field_type === "date" && {
            is_future_dates_allowed:
              item.validation.find(
                (v: { type: string }) => v.type === "is_future_dates_allowed",
              )?.value || null,
          }),
          ...(item.field_type === "date" && {
            is_past_dates_allowed:
              item.validation.find(
                (v: { type: string }) => v.type === "is_past_dates_allowed",
              )?.value || null,
          }),
          ...((item.field_type === "image" || item.field_type === "media" || item.field_type === "file") && {
            max_size:
              item.validation.find(
                (v: { type: string }) => v.type === "max_file_size",
              )?.value || undefined,
            is_multiple: item.field_properties?.is_multiple
          }),
          ...((item.field_type === "toggleButton" || item.field_type === "checkbox" || item.field_type === "radioButton") && {
            title: item.field_properties?.title ? item.field_properties?.title : '',
            title_position: item.field_properties?.title_position ?? "end",
            is_checked: item.field_properties?.is_checked
          }),
          ...((item.field_type === "table") && {
            table: item.field_properties?.table,
            table_columns: convertTableColumns(item.field_properties?.table_columns),
            table_rows: item.field_properties?.table_rows,
            otherButtons: item.field_properties?.other_buttons || []
          }),
        };
        if (currentSection) {
          currentSection.members.push(member);
          if (
            currentSection.members.some((member: any) => member.type === "system")
          ) {
            currentSection.remove_section = true;
          } else {
            currentSection.remove_section = false;
          }
          currentTab.remove_tab = currentTab.data.some(
            (section: { members: any[] }) =>
              section.members.some(
                (member: { type: string }) => member.type === "system",
              ),
          );
        }
      }
    });
  } else {
    // Convert to sections format
    outputData.section = [];
    let currentSection: {
      label: any;
      members: any;
      remove_section: any;
      field_type?: string;
      is_accordion?: boolean;
    } | null = null;
    let otherSectionDetails: any = {}
    let sectionOrder: any = null

    formData.forEach(
      (item: ItemType) => {
        if (item.is_section_field) {
          otherSectionDetails = {
            field_type: item?.field_type,
            label: item?.label,
            is_accordion: item?.is_accordion,
            is_section_field: item?.is_section_field,
            section_type: item?.section_type,
            form_switcher_label: item?.form_switcher_label,
            form_switcher_name: item?.form_switcher_name,
            switcher_forms: item?.switcher_forms,
            disabled: Boolean(item?.disabled)
          }
          sectionOrder = sectionOrder++
          currentSection = null
        } else {
          if (!currentSection || currentSection.label !== item.section_name || sectionOrder !== item.section_order) {
            currentSection = {
              field_type: "section",
              label: item.section_name || "",
              is_accordion: item.field_properties?.is_accordion,
              members: [],
              remove_section: item.is_system_field === true ? true : false,
            };

            const checkIfSectionExist = outputData?.section?.find(section => section.label === currentSection?.label)
            if (!checkIfSectionExist) {
              // Merge section details and update currentSection reference to the actual pushed object
              currentSection = { ...otherSectionDetails, ...currentSection };
              outputData.section.push(currentSection);
            } else {
              currentSection = checkIfSectionExist
            }

            // outputData.section.push({ ...otherSectionDetails, ...currentSection });

            otherSectionDetails = null
          }
          sectionOrder = item.section_order

          const thenValidations = item?.validation?.find((v: { type: string }) => v.type === "when")?.thenValidations || []

          const member = {
            ...item,
            id: `${Date.now()}-${Math.random()}`,
            field_type:
              item.field_type === "media" ? "file" : item.field_type || "text",
            type: item.is_system_field ? "system" : "custom",
            label: item.label,
            placeholder: item.placeholder || "",
            default_value: item.default_value || "",
            ...(item?.time_format &&
              item?.field_type === "time" && { option: item?.time_format }),
            ...(item?.currency &&
              item?.field_type === "currency" && { option: item?.currency }),
            ...(item.field_type === "text" && {
              min_length:
                item.validation.find(
                  (v: { type: string }) => v.type === "min_length",
                )?.value || null,
            }),
            ...(item.field_type === "text" && {
              max_length:
                item.validation.find(
                  (v: { type: string }) => v.type === "max_length",
                )?.value || null,
            }),
            ...(item.field_type === "number" && {
              min_length:
                item.validation.find(
                  (v: { type: string }) => v.type === "min_val",
                )?.value || null,
            }),
            ...(item.field_type === "number" && {
              max_length:
                item.validation.find(
                  (v: { type: string }) => v.type === "max_val",
                )?.value || null,
            }),
            ...((item.is_multiline !== undefined || item.field_properties?.is_multiline !== undefined) && {
              is_multiline: item.is_multiline || item.field_properties?.is_multiline,
            }),
            is_required:
              item.validation.find((v: { type: string }) => v.type === "required")?.value ||
              thenValidations?.find((v: { type: string }) => v.type === "required")?.value ||
              false,
            is_unique:
              item.validation.find((v: { type: string }) => v.type === "unique")
                ?.value || false,
            section_order: item.section_order || 0,
            ...(item.field_properties?.float_step && {
              float_step: Number(item.field_properties.float_step),
            }),
            ...(item.field_properties?.options && {
              options: item.field_properties.options,
            }),
            ...(item.field_properties?.is_multiselect !== undefined && {
              is_multiselect: item.field_properties.is_multiselect,
            }),
            ...(item.field_properties?.enable_footer !== undefined && {
              enable_footer: Boolean(item.field_properties.enable_footer),
            }),
            ...(item.field_properties?.footer_action !== undefined && {
              footer_action: item.field_properties.footer_action || 'add',
            }),
            ...(item.field_type === "date" && {
              is_future_dates_allowed:
                item.validation.find(
                  (v: { type: string }) => v.type === "is_future_dates_allowed",
                )?.value || null,
            }),
            ...(item.field_type === "date" && {
              is_past_dates_allowed:
                item.validation.find(
                  (v: { type: string }) => v.type === "is_past_dates_allowed",
                )?.value || null,
            }),
            ...((item.field_type === "image" || item.field_type === "media" || item.field_type === "file") && {
              max_size:
                item.validation.find(
                  (v: { type: string }) => v.type === "max_file_size",
                )?.value || undefined,
              is_multiple: item.field_properties?.is_multiple
            }),
            ...((item.field_type === "toggleButton" || item.field_type === "checkbox") && {
              title: item.field_properties?.title ? item.field_properties?.title : item.label,
              title_position: item.field_properties?.title_position ?? "end",
              is_checked: item.field_properties?.is_checked
            }),
            ...((item.field_type === "table") && {
              table: item.field_properties?.table,
              table_columns: convertTableColumns(item.field_properties?.table_columns),
              table_rows: item.field_properties?.table_rows,
              otherButtons: item.field_properties?.other_buttons || []
            }),
          };

          currentSection.members.push(member);
          if (
            currentSection.members.some((member: any) => member.type === "system")
          ) {
            currentSection.remove_section = true;
          } else {
            currentSection.remove_section = false;
          }
        }
      }
    );
  }

  return outputData;
};



function formatText(key: string): string {
  return key ? key
    .split(/[:_-]/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ") : key;
}

export const convertTableColumns = (columns: string[]) => {
  if (!Array.isArray(columns)) return [];

  return columns.map(column => {
    if (typeof column === 'object') {
      return { ...column }
    } else {
      const colArr = column.split(".").filter(str => str)
      const header = colArr.length ? (colArr.length > 1 ? formatText(colArr[colArr.length - 1]) : formatText(colArr[0])) : "-"

      return {
        header,
        accessorKey: column,
        visible: true,
      }
    }
  })
}

export default formBuilderDeConversion;
